import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';

import { AntiAuthGuardService } from './shared/services/auth/anti-auth-guard/anti-auth-guard.service';
import { RedirectGuardService } from './shared/services/auth/redirect-guard/redirect-guard.service';

import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'licence',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'workspace',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'bot',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    path: 'utilities',
    loadChildren: () => import('./idechat/idechat.module').then(m => m.IdechatModule)
  },
  {
    // Login page is is only available when localLogin is set to true in envs
    path: 'login',
    canActivate: [environment.localLogin ? AntiAuthGuardService : RedirectGuardService],
    component: environment.localLogin ? LoginComponent : RedirectGuardService,
    data: {
      url: `${environment.products.connect}/login`
    },
    pathMatch: 'full'
  },
  { path: '**', component: PageNotFoundComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      paramsInheritanceStrategy: 'always'
      /*      enableTracing: true */
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
